<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg1">
    <div class="container">
        <div class="inner-title text-center">
            <h3>{{productDetails.name}}</h3>
        </div>
    </div>
</div>

<div class="mt-5">
    <!-- <div class="goBackBtn text-end px-5">
        <a (click)="goBack()"><i style="font-size: 25px;" class="fa fa-arrow-left"></i></a>
    </div> -->
    <div class="alert alert-success" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
        {{successMsg}}
    </div>
    <div class="container-fluid">
        <div class="inner-banner-title text-center" *ngIf="productDetails">
            <img class="productImage" src="{{productDetails.avatar}}" alt="{{productDetails.name}}">

            <!-- <a class="heart-btn" (click)="toggleFavourite(productDetails.id)" style="color: #000;position: absolute;top: 6%;right: 20px;font-size: 28px;">
                <i *ngIf="isFav" class="fa fa-heart"></i>
                <i *ngIf="!isFav" class="fa-regular fa-heart"></i>
            </a>
    
            <a href="cart" class="cart_shopping" style="color: #000;position: absolute;top: 6%;right: 70px;font-size: 28px;">
                <i class="fa fa-cart-shopping"></i>
                <span>{{quantityCounter}}</span>
            </a> -->

            <div class="container">
                <div class="row">
                    <div class="col-12 text-center px-0">
                        <h3 class="subCategoryName">{{productDetails.name | titlecase}}</h3>
                    </div>
                    <div class="col-12 text-center px-0">
                        <span class="plusBtn" *ngIf="!productQuantities[productDetails.id] || productQuantities[productDetails.id] === 0" 
                            (click)="quantity(productDetails.id, 1)">+</span>
                        <div class="number m-auto" *ngIf="productQuantities[productDetails.id] && productQuantities[productDetails.id] >= 1">
                            <span class="minus" (click)="quantity(productDetails.id, -1)">-</span>
                            <input type="text" id="quantity{{productDetails.id}}" [value]="productQuantities[productDetails.id]" readonly/>
                            <span class="plus" (click)="quantity(productDetails.id, 1)">+</span>
                        </div>
                    </div>

                    <div class="col-12 mt-4">
                        <div class="row" style="border-top: 1px solid #ccc; padding: 30px 0 10px 0;">
                            <div class="col-12 text-start">
                                <h3>المكونات</h3>
                            </div>
                            <div class="col-12 text-start">
                                <p *ngFor="let component of productDetails.components">{{component.name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2">
                        <div class="row" style="border-top: 1px solid #ccc; padding: 30px 0;">
                            <div class="col-6 text-start">
                                <h3>الاحجام</h3>
                            </div>
                            <div class="col-6 text-end" dir="ltr">
                                <h3 style="color: red;">مطلوب</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 pb-4">
                        <div class="row" *ngFor="let type of productDetails.types">
                            <div class="col-6 text-start">
                                <span class="sizes">
                                    <!-- <input type="radio" [value]="type.abbrev" name="size-{{productDetails.id}}" (change)="calcTotal(type.price)" [id]="type.abbrev+'-'+productDetails.id"> -->
                                    <input type="radio" [value]="type.abbrev" name="size-{{productDetails.id}}" 
                                    (change)="selectSize(productDetails.id, type); calcTotal(type.price)" 
                                    [id]="type.abbrev+'-'+productDetails.id">
                                    <label [for]="type.abbrev+'-'+productDetails.id">{{ type.name }}</label>
                                </span>
                            </div>
                            <div class="col-6 text-end" dir="ltr">
                                <h3 dir="rtl">{{type.price}} EGP</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" style="border-top: 1px solid #ccc;padding: 10px 0;">
                        <div class="row">
                            <div class="col-6 text-start">
                                <h6>المجموع</h6>
                            </div>
                            <div class="col-6 text-end" dir="rtl">
                                <h3>{{lastValue}} EGP</h3>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-5 mt-4" *ngIf="getTotalAddedQuantity() > 0">
                        <button class="btn btn-custom" (click)="sendCart()" [disabled]="lastValue == 0">
                            <span style="position: relative;">
                                <i class="fa fa-cart-shopping"></i>
                                <span class="cart-number">{{ getTotalAddedQuantity() }}</span>
                            </span> إضافة الي السلة
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<!-- Button trigger modal -->
<button type="button" id="openModal" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>
        
<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">تسجيل الدخول</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p class="signInFirst">
                    برجاء تسجيل الدخول اولا
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">الغاء</button>
                <a href="login-register" type="button" class="btn btn-primary">تسجيل الدخول</a>
            </div>
        </div>
    </div>
</div>


<!-- <div class="inner-banner inner-bg7">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Products Details</h3>
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Pages</li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Products Details</li>
            </ul>
        </div>
    </div>
</div> -->

<!--<app-footer-style-two></app-footer-style-two> -->